/*
 * @Date: 2022-08-30 14:56:51
 * @LastEditTime: 2022-09-06 11:12:18
 * @Description: file content
 * @FilePath: \traffic\src\components\conversation\lastMessageType.jsx
 */
import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

const LastMessageLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #bfbfbf;
  width: 100%;
  margin-top: auto;
  span {
    width: max-content;
    display: inline-block;
  }
`;

const EllipsisDiv = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  flex: 1;
`;

const renderCommon = (params) => {
  return [params?.before, params?.name, params?.desc]
    .filter((item) => item)
    .join(params.join);
};

const typeParams = new Map();
typeParams.set('image', '[图片]');
typeParams.set('video', '[视频]');
typeParams.set('voice', '[语音]');
typeParams.set('position', '[位置]');
typeParams.set('expression', '[表情]');
typeParams.set('file', '[文件]');
typeParams.set('redEnvelopes', '[红包]');
typeParams.set('transferAccounts', '[转账]');
typeParams.set('withdraw', '撤回了一条消息');
typeParams.set('delete', '删除了一条消息');

const renderType = (type, record) => {
  const isUserAction = ['withdraw', 'delete'].includes(type);
  // 外部好友,内部好友不需要展示姓名
  const name = record?.name;
  let desc = typeParams.get(type) || '[其他]';
  if (['text', 'link'].includes(type)) {
    desc = `(${record?.text})`;
  }
  const params = {
    name,
    desc,
    before: isUserAction ? '发送人' : '',
    join: isUserAction ? '' : ':',
  };
  return renderCommon(params);
};

/**
 * @param {{ message, nowDay }} props
 * */
export default function LastMessageType(props) {
  const { data } = props;
  // 如果“最近一次会话的时间”与当前时间为同一天，则展示当前时间即可，格式为时/分（如16:16）
  // 如果“最近一次会话的时间”与当前时间不是同一天，则展示“最近一次会话时间”对应的日期即可，格式为年/月/日（其中年仅显示后两位数字，如果2022，显示为22）
  let time = '2022/08/30 16:16';
  if (time.includes(props.nowDay)) {
    time = time.replace(props.nowDay, '');
  }
  // const Wrapper = data?.lastMsgContent?.length > 15 ? Tooltip : React.Fragment;
  const Wrapper = React.Fragment
  return (
    <LastMessageLine className='last-message-line'>
      {/* <EllipsisDiv>{renderType(type, { name: '默认' })}</EllipsisDiv> */}
      <Wrapper color="#fff" title={data?.lastMsgContent}>
        <EllipsisDiv>{data?.lastMsgContent}</EllipsisDiv>
      </Wrapper>
      <span style={{ paddingLeft: '20px' }}>{data?.lastMsgDateTime}</span>
    </LastMessageLine>
  );
}
